export default __webpack_public_path__ + "static/media/payment-info-complete-1x.82347653.jpg";